import { cn } from '@/lib/utils';

export interface ChartCardProps {
  /** Chart title displayed at the top */
  title?: string;
  /** Additional content rendered below the chart (e.g., legend, notes) */
  footer?: React.ReactNode;
  /** Whether the chart is loading */
  loading?: boolean;
  /** Error message to display */
  error?: string | null;
  /** Chart content */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Card container for chart components.
 * Provides consistent styling per the OUTFRONT design system.
 */
export function ChartCard({
  title,
  footer,
  loading = false,
  error = null,
  children,
  className,
}: ChartCardProps) {
  return (
    <div className={cn('bg-white border border-neutral-200 rounded-lg p-5', className)}>
      {title && (
        <h3 className="text-[15px] font-semibold text-[#111111] mb-4 pb-2 border-b border-neutral-200">
          {title}
        </h3>
      )}
      {loading ? (
        <div
          className="flex items-center justify-center h-[300px]"
          aria-busy="true"
        >
          <div className="animate-pulse bg-neutral-200 rounded w-full h-full" />
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-[300px]">
          <p className="text-sm text-[#B91C1C]">{error}</p>
        </div>
      ) : (
        children
      )}
      {footer && <div className="mt-4 pt-3 border-t border-neutral-200">{footer}</div>}
    </div>
  );
}

export default ChartCard;
